import { useEffect, useState } from 'react'
import { api, type VisitaResumo } from '../api/cliente'
import { Cabecalho, Carregando, Erro } from '../componentes/Basicos'
import { emBr } from '../datas'

/**
 * As visitas do auditor, da mais recente para a mais antiga.
 *
 * **A web não cria visita.** Visita nasce em campo, junto com o bloco documental e os quadros —
 * criar uma aqui produziria uma visita sem nada dentro, que o app teria de adotar. Esta peça
 * lista e entrega.
 */
export function Visitas({
  aoAbrir,
  aoAbrirContas,
}: {
  aoAbrir: (visita: VisitaResumo) => void
  aoAbrirContas: () => void
}) {
  const [visitas, setVisitas] = useState<VisitaResumo[] | null>(null)
  const [erro, setErro] = useState<unknown>(null)

  useEffect(() => {
    api.visitas().then(setVisitas).catch(setErro)
  }, [])

  if (erro) return <div className="corpo"><div className="limite"><Erro erro={erro} /></div></div>
  if (!visitas) return <Carregando o="as visitas" />

  return (
    <>
      <Cabecalho
        titulo="Laudos NR10"
        sub={visitas.length === 1 ? '1 visita' : `${visitas.length} visitas`}
        acoes={
          <>
            <button className="btn g sm" onClick={aoAbrirContas}>
              Auditores
            </button>
            {/* Recarregar a página era o jeito antigo de voltar ao login. Agora o `sair` avisa o
                App, que troca a tela — e a diferença aparece quando é o 401 quem chama, no meio
                de uma requisição, onde recarregar não seria opção. */}
            <button className="btn g sm" onClick={() => api.sair()}>
              Sair
            </button>
          </>
        }
      />
      <div className="corpo">
        <div className="limite">
          {visitas.length === 0 ? (
            <div className="vazio">
              Nenhuma visita ainda. As visitas nascem no app de campo, não aqui.
            </div>
          ) : (
            <ul className="lista">
              {visitas.map((visita) => (
                <li key={visita.id} className="item">
                  <div className="dados">
                    <div className="linha1">
                      <b>{visita.cliente}</b>
                      <span className="setor">{visita.planta}</span>
                    </div>
                    <div className="linha2">
                      {emBr(visita.data)}
                      {' · '}
                      {visita.quadros === 0
                        ? 'nenhum quadro fechado'
                        : `${visita.quadros} ${
                            visita.quadros === 1 ? 'quadro fechado' : 'quadros fechados'
                          }`}
                    </div>
                  </div>
                  <button className="btn sm" onClick={() => aoAbrir(visita)}>
                    Abrir
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  )
}
